<template>
  <b-overlay :show="isLoading" rounded="sm">
    <div v-if="reportsList !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1 class="mb-2">لیست گزارشات چت</h1>
        <!-- Table Top -->
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="reportsList"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
        >
          <template #cell(createDate)="data">
            <div class="cursor-pointer d-flex flex-row">
              {{
                new Date(data.item.createDate).toLocaleTimeString("fa-IR", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
              }}
              -
              {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
            </div>
          </template>
          <template #cell(fromUser)="data">
            <router-link
              :to="{
                name: 'apps-users-edit',
                params: { id: data.item.fromUserId },
              }"
            >
              {{ data.item.fromUser }}
            </router-link>
          </template>
          <template #cell(toUser)="data">
            <router-link
              :to="{
                name: 'apps-users-edit',
                params: { id: data.item.toUserId },
              }"
            >
              {{ data.item.toUser }}
            </router-link>
          </template>
          <template #cell(view)="data">
            <button
              @click="renderReportMessageModal(data.item)"
              type="button"
              class="btn btn-transparent"
            >
              <feather-icon icon="EyeIcon" size="20" class="text-primary" />
            </button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="pageNumber"
                :total-rows="totalCount"
                :per-page="count"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-modal
        title="مشاهده محتوای گزارش"
        id="modal-report-message"
        centered
        ok-title="بستن"
        ok-only
        @ok="closeMessageModal"
      >
        <p dir="auto" v-if="tempReportDescription">
          {{ tempReportDescription }}
        </p>
        <small v-else>هیچ توضیحاتی برای این گزارش ثبت نشده است!</small>
      </b-modal>
    </div>
  </b-overlay>
</template>
<script>
import UserReportGetAllRequest from "@/libs/Api/UserReport/GetUserReportListRequest";
import UserReportDetailsRequest from "@/libs/Api/UserReport/GetUserReportDetailsRequest";
export default {
  name: "reports-list",
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllReports();
      },
    },
  },
  mounted() {
    this.getAllReports();
  },
  data() {
    return {
      isLoading: false,
      reportsList: null,
      count: 10,
      pageNumber: 1,
      totalCount: null,
      tempReportItem: null,
      tempReportDescription: null,
      myTableColumns: [
        { key: "id", label: "شناسه" },
        { key: "fromUser", label: "کاربر گزارش دهنده" },
        { key: "toUser", label: "کاربر گزارش شده" },
        { key: "createDate", label: "تاریخ ایجاد" },
        { key: "view", label: "جزئیات" },
      ],
    };
  },

  methods: {
    closeMessageModal() {
      this.$bvModal.hide("modal-report-message");
    },
    async renderReportMessageModal(reportItem) {
      this.tempReportItem = reportItem;
      await this.getReportDetails(this.tempReportItem.id);
      this.$bvModal.show("modal-report-message");
    },
    async getReportDetails(id) {
      try {
        this.isLoading = true;
        let _this = this;
        let userReportDetailsRequest = new UserReportDetailsRequest(_this);
        userReportDetailsRequest.setParams({ id });
        await userReportDetailsRequest.fetch((res) => {
          if (res.des) {
            _this.tempReportDescription = res.des;
          } else {
            _this.tempReportDescription = null;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllReports() {
      try {
        this.isLoading = true;
        let _this = this;
        let userReportGetAllRequest = new UserReportGetAllRequest(_this);
        userReportGetAllRequest.setParams({
          pageNumber: _this.pageNumber,
          count: _this.count,
        });
        await userReportGetAllRequest.fetch((res) => {
          _this.reportsList = res.items;
          _this.totalCount = res.totalCount;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
</script>
